<template>
  <advance-feature-table />
</template>

<script>
import AdvanceFeatureTable from './AdvanceFeatureTable.vue';
export default {
  components: {
    AdvanceFeatureTable,
  },
};
</script>
